import React, { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import api from "../services/api";
import { useAuth } from "./AuthContext";

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companies, setCompanies] = useState([]);
  const { isAuthenticated, isLoading } = useAuth();

  const fetchCompanies = async () => {
    try {
      await api.get(`${process.env.REACT_APP_API_URL}/api/get-csrf-token/`);
      const response = await api.get(`${process.env.REACT_APP_API_URL}/api/companies/`);
      const companiesData = response.data.companies;
      setCompanies(companiesData);

      // Nustatome pasirinktą įmonę pagal 'is_current' lauką
      const currentCompany = companiesData.find((company) => company.is_current);

      if (currentCompany) {
        setSelectedCompany(currentCompany);
      } else if (companiesData.length > 0) {
        setSelectedCompany(companiesData[0]);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      fetchCompanies();
    }
  }, [isAuthenticated, isLoading]);

  // Funkcija atnaujinti pasirinktą įmonę tiek kontekste, tiek serveryje
  const updateSelectedCompany = async (company) => {
    try {
      setSelectedCompany(company);
      await api.post(`${process.env.REACT_APP_API_URL}/api/change-company/`, {
        company_id: company.id,
      });
    } catch (error) {
      console.error("Error updating selected company:", error);
    }
  };

  return (
    <CompanyContext.Provider
      value={{
        selectedCompany,
        setSelectedCompany: updateSelectedCompany, // Naudojame atnaujintą funkciją
        companies,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

CompanyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCompany = () => useContext(CompanyContext);

export default CompanyContext;
